import { render, staticRenderFns } from "./buddy_prefs.vue?vue&type=template&id=29aa63fb&scoped=true&"
import script from "./buddy_prefs.vue?vue&type=script&lang=js&"
export * from "./buddy_prefs.vue?vue&type=script&lang=js&"
import style0 from "./buddy_prefs.vue?vue&type=style&index=0&id=29aa63fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa63fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
